import * as React from 'react';

interface IRingIcon {
  className?: string;
}

export function RingIcon(props: IRingIcon) {
  return (
    <svg
      className={props.className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0379 5.33187V5.06452C12.0379 2.82 10.2179 1 7.97341 1V1C5.7289 1 3.9089 2.82 3.9089 5.06452V5.33187C3.9089 6.61716 3.22515 7.81213 2.10967 8.45161C1.5307 8.784 1.19922 9.16877 1.19922 9.58064C1.19922 10.828 4.23225 11.8387 7.97341 11.8387C11.7146 11.8387 14.7476 10.828 14.7476 9.58064C14.7476 9.16877 14.4161 8.784 13.8372 8.45161C12.7217 7.81303 12.0379 6.61716 12.0379 5.33187Z"
        stroke="#737A8E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0427 14.0968C9.69409 14.6285 8.89834 15 7.97254 15C7.04673 15 6.25189 14.6285 5.90234 14.0974"
        stroke="#737A8E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
